import { Action } from '@ngrx/store';
import { LargeShareholderSearchFilter } from '../../models/largeShareholderSearchFilter';

export enum ELargeShareholderListActions {
  SetSearchFilter = '[Large Shareholder List] SET SEARCH FILTER',
  SetPagination = '[Large Shareholder List] SET PAGINATION',
  SetSort = '[Large Shareholder List] SET SORT',
  ClearFilters = '[Large Shareholder List] CLEAR FILTERS'
}

export class SetSearchFilter implements Action {
  public readonly type = ELargeShareholderListActions.SetSearchFilter;
  constructor(public payload: LargeShareholderSearchFilter) {}
}

export class SetPagination implements Action {
  public readonly type = ELargeShareholderListActions.SetPagination;
  constructor(public payload: { currentPage: number; pageSize: number }) {}
}

export class SetSort implements Action {
  public readonly type = ELargeShareholderListActions.SetSort;
  constructor(public payload: { sortBy: string; ascending: boolean }) {}
}

export class ClearFilters implements Action {
  public readonly type = ELargeShareholderListActions.ClearFilters;
}

export type LargeShareholderListActions =
  | SetSearchFilter
  | SetPagination
  | SetSort
  | ClearFilters;
